module.exports = __webpack_public_path__ + "static/media/gl.e544ff8a.svg";